import React, {Component} from 'react';
import {connect} from 'react-redux';
import StackOptions from './stack-options';
import Action from 'components/organisms/non-controlled-hitter-stacking/actions';
import ChooseTeamsRandomly from './choose-teams-randomly';
import CombinationOptions from './combination-options';

class Stacks extends Component {
    componentDidMount() {
        this.props.dispatch(Action.setTeams(this.props.games));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.props.dispatch(Action.setTeams(this.props.games));
    }

    render() {
        return (
            <div className="white-box">
                <h2 className="mb15">Hitter Stack Rules</h2>
                <div className="checkbox mb15">
                    <ChooseTeamsRandomly />
                </div>
                <CombinationOptions />
                <div className="stack-filter">
                    <StackOptions stackNumber={1} />
                    <StackOptions stackNumber={2} />
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        playersData: {
            filters: {games},
        },
    } = state;
    return {
        games,
    };
}

export default connect(mapStatesToProps)(Stacks);
